import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyAXr5YyZfdVwSZlAmPM6m39qddFNpxK9lE",
    authDomain: "affinityclub-417b8.firebaseapp.com",
    projectId: "affinityclub-417b8",
    storageBucket: "affinityclub-417b8.firebasestorage.app",
    messagingSenderId: "892589131323",
    appId: "1:892589131323:web:76a89a9c8fbf6f3b063e1e",
    measurementId: "G-CE0RD3XVW3"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app; 